import { useNavigate } from "react-router-dom";
import { Upload, Search, FileText, Mail, GitMerge, FileSpreadsheet } from "lucide-react";

const ADMIN_ACTIONS = [
  { label: "Import Orders", desc: "Upload a Shopify or PayPal file", icon: Upload, path: "/import", testId: "action-import-orders" },
  { label: "Find a Customer", desc: "Search by name, email, or phone", icon: Search, path: "/customers", testId: "action-find-customer" },
  { label: "Generate Statements", desc: "Year-end giving statements as PDFs", icon: FileText, path: "/statements", testId: "action-generate-statements" },
  { label: "Send an Email", desc: "Write to a group of customers", icon: Mail, path: "/email", testId: "action-send-email" },
];

const STAFF_ACTIONS = [
  { label: "Find a Customer", desc: "Search by name, email, or phone", icon: Search, path: "/customers", testId: "action-find-customer" },
  { label: "Review Duplicates", desc: "Check possible duplicate records", icon: GitMerge, path: "/duplicates", testId: "action-review-duplicates" },
  { label: "Reports & Export", desc: "Revenue summary by category", icon: FileSpreadsheet, path: "/reports", testId: "action-reports" },
];

export const QuickActions = ({ role }) => {
  const navigate = useNavigate();
  const actions = role === "admin" ? ADMIN_ACTIONS : STAFF_ACTIONS;

  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-serif font-semibold mb-5">What would you like to do?</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {actions.map(({ label, desc, icon: Icon, path, testId }) => (
          <button
            key={label}
            onClick={() => navigate(path)}
            data-testid={testId}
            className="text-left rounded-lg border border-border bg-card p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 hover:border-primary/40 transition-shadow duration-200 group"
          >
            <div className="h-11 w-11 rounded-md bg-primary flex items-center justify-center">
              <Icon className="h-5 w-5 text-primary-foreground" />
            </div>
            <p className="font-semibold mt-4 group-hover:text-primary transition-colors duration-200">{label}</p>
            <p className="text-sm text-muted-foreground mt-1">{desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
};
